// Third Party Imports
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {get} from 'lodash';
import base64 from 'base-64';

// Relative Imports
import actions from '../../actions/actions';
import MasterBrandPage from './MasterBrand';
import masterBrandActions from '../../actions/masterBrand';

function mapStateToProps(state) {
    return {
        state,
        errorKey: get(state, 'masterBrand.errorKey', false),
        publicUuid: get(state, 'app.publicUuid', '-1'),
        siteName: state.system.siteName,
        translations: state.app.translations,
        brandName:  get(state, 'masterBrand.brandName', ''),
        hostName: get(state, 'masterBrand.hostName', ''),
        redirectFlag: get(state, 'masterBrand.redirectFlag', false),
        redirectLink: get(state, 'masterBrand.redirectLink', ''),
        userCurrency: get(state, 'masterBrand.userCurrency', ''),
        currency: get(state, 'currency.currency', ''),
        supportedCurrencies: get(state, 'currency.supportedCurrencies', {}),
        firstName: get(state, 'basicInformation.firstName', ''),
        lastName: get(state, 'basicInformation.lastName', '')
    };
}

function mapDispatchToProps(dispatch) {
    return {actions: bindActionCreators(actions, dispatch),
        masterBrandActions: bindActionCreators(masterBrandActions, dispatch),
        dispatch};
}

@connect(mapStateToProps, mapDispatchToProps)
export default class MasterBrandContainer extends React.Component {
    constructor(props) {
        super(props);
        this.triggerEdapPageViewAction = this.triggerEdapPageViewAction.bind(this);
        this.handleContinueButtonClick = this.handleContinueButtonClick.bind(this);
        this.handleBackButtonClick = this.handleBackButtonClick.bind(this);
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
    }

    componentWillMount() {
        const {currency, supportedCurrencies, siteName} = this.props;
        this.props.actions.enableLoadOverLay(false);
        this.props.masterBrandActions.getRedirectBrandDetails(currency, supportedCurrencies, siteName);
    }

    triggerEdapPageViewAction() {
        this.props.actions.triggerEdapPageView(this.props.publicUuid, 'Master Brand Page');
    }

    handleContinueButtonClick(event) {
        event.preventDefault();
        this.props.actions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue'
        }, {});

        const {redirectFlag, redirectLink, firstName, lastName, userCurrency} = this.props;
        if (redirectFlag) {
            const prefillValue = base64.encode(`currency=${userCurrency}&firstName=${firstName}&lastName=${lastName}`);
            window.location = (redirectLink.indexOf('=') > -1) ? `${redirectLink}&brandSwitchConfirmed=${prefillValue}` : `${redirectLink}?brandSwitchConfirmed=${prefillValue}`;
        } else {
            this.props.actions.changeAppState('COMPANY_LOCATION');
        }
    }

    handleBackButtonClick(event) {
        event.preventDefault();
        this.props.actions.triggerEdapEvent('generic.click', {
            eventcategory: 'Back'
        });
        this.props.actions.changeAppState('SUPPORTED_CURRENCY');
    }

    handleAlertDismiss() {
        this.props.masterBrandActions.alertError('');
    }

    render() {
        const {translations, errorKey} = this.props;

        return (
            <MasterBrandPage translations={translations}
                triggerEdapPageViewAction={this.triggerEdapPageViewAction}
                handleContinueButtonClick={this.handleContinueButtonClick}
                handleBackButtonClick={this.handleBackButtonClick}
                triggerEdapEvent={this.triggerEdapEvent}
                errorKey={errorKey}
                handleAlertDismiss={this.handleAlertDismiss}
                brandName={this.props.brandName}
                hostName={this.props.hostName}
            />
        );
    }
}
MasterBrandContainer.propTypes = {
    translations: PropTypes.any // eslint-disable-line react/forbid-prop-types
};
